import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import LandingPage from './components/LandingPage';
import BlogIndex from './components/blog/BlogIndex';
import BlogPost from './components/blog/BlogPost';
import ContactPage from './components/ContactPage';
import MentionsLegales from './components/legal/MentionsLegales';
import Confidentialite from './components/legal/Confidentialite';
import CGV from './components/legal/CGV';
import DiagnosticWizard from './components/DiagnosticWizard';
import ExpertChat from './components/chat/ExpertChat';
import CookieBanner from './components/CookieBanner';
import { AuthProvider } from './context/AuthContext';
import { trackPage } from './utils/analytics';

// Suivi des changements de page
function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPage(location.pathname + location.search);
  }, [location]);
  return null;
}

export default function App() {
  const [wizardOpen, setWizardOpen] = useState(false);
  const openWizard = () => setWizardOpen(true);
  const closeWizard = () => setWizardOpen(false);

  return (
    <HelmetProvider>
      <AuthProvider>
      <BrowserRouter>
        <PageTracker />
        <div className="dark">
          <Routes>
            <Route path="/"                element={<LandingPage />} />
            <Route path="/blog"            element={<BlogIndex onOpenWizard={openWizard} />} />
            <Route path="/blog/:slug"      element={<BlogPost onOpenWizard={openWizard} />} />
            <Route path="/contact"         element={<ContactPage onOpenWizard={openWizard} />} />
            <Route path="/mentions-legales" element={<MentionsLegales onOpenWizard={openWizard} />} />
            <Route path="/confidentialite" element={<Confidentialite onOpenWizard={openWizard} />} />
            <Route path="/cgv"             element={<CGV onOpenWizard={openWizard} />} />
          </Routes>

          {/* Wizard global */}
          <DiagnosticWizard isOpen={wizardOpen} onClose={closeWizard} />

          {/* Chat expert IA — flottant sur toutes les pages */}
          <ExpertChat />

          {/* Bannière consentement cookies CNIL */}
          <CookieBanner />
        </div>
      </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}
